// extracted by mini-css-extract-plugin
export var numpadContainer = "_o9-1";
export var phoneButton = "_o9-0";